import React from 'react';
import { useDispatch } from 'react-redux';

import { Button } from 'common-src/components/base';
import { ColorsNew } from 'common-src/styles';

import useAlert from 'src/hooks/useAlert';
import { subscribeAndVerifyAppointmentChanges } from 'src/utils/athenaUtils';

import styles from './AthenaScreen.module.scss';

const AthenaScreen = () => {
  const dispatch = useDispatch();
  const { showAlert, AlertType } = useAlert();

  const handleSubscribeAndVerify = () => {
    subscribeAndVerifyAppointmentChanges(dispatch, showAlert, AlertType);
  };

  return (
    <div className={[styles.container, 'flex-column'].join(' ')}>
      <header className={[styles.headerContainer, 'vertically-centered'].join(' ')}>
        <span className={[styles.text, 'font-s-20', 'font-w-700'].join(' ')}>Athena</span>
      </header>
      <div className={styles.buttonRow}>
        <Button
          id="push-appointments-button"
          text="Subscribe & Verify"
          backgroundColor={ColorsNew.darkGreen}
          textColor={ColorsNew.white}
          classNames={[styles.button]}
          onClick={handleSubscribeAndVerify}
        />
        <span className={styles.buttonDescription}>Subscribe &amp; Verify Appointment Changes</span>
      </div>
    </div>
  );
};

export default AthenaScreen;
